import {
  Component,
  EventEmitter,
  Output,
  ViewChild,
  Input
} from "@angular/core";

import { GoogleMapsProvider } from "../../providers/google-maps/google-maps";

/**
 * Generated class for the GoogleMapsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "google-maps",
  templateUrl: "google-maps.html",
  styleUrls:['./google-maps.scss']
})
export class GoogleMapsComponent {
  @ViewChild("maps")
  mapDiv;
  @Output("mapLoaded")
  mapLoaded: EventEmitter<any>;

  @Input("maxZoom")
  maxZoom: number = 15;

  marker;
  map;
  constructor(private googleMaps: GoogleMapsProvider) {
    this.mapLoaded = new EventEmitter();
  }

  ngOnInit() {
    this.googleMaps.getGoogle().then(google => {
      let mapOptions = {
        center: { lat: 48, lng: 8 },
        zoom: 15,
        maxZoom: this.maxZoom,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true
      };
      this.map = new google.maps.Map(this.mapDiv.nativeElement, mapOptions);
      this.mapLoaded.emit(this.map);
    });
  }

  ngOnDestroy() {}
}
